module.exports = __webpack_public_path__ + "img/5.c6d6d6bd.jpg";